import { FaturaAtendimentosListSearchComponent } from './FaturaAtendimentosListSearchComponent'
import { FaturaAtendimentosListToolbar } from './FaturaAtendimentosListToolbar'

export const FaturaAtendimentosListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <FaturaAtendimentosListSearchComponent actions={<FaturaAtendimentosListToolbar />} />
  </div>
)
